import React from "react"
import {Input, Label} from "reactstrap"

const FilePicker = (props) => <div className="mb-3">
    <Label>{props.label}</Label>
    <Input
        className="form-control"
        type={"file"}
        {...props}
    />
</div>

export default FilePicker